<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<h1>INTRODUCTION
           </h1>
</div>
<p class="fp" id="rw-fp_131470-00001">I used to find it difficult to think of myself as a poet. It felt too grand a title. There was something bloodless about it. Something severe. Gil Scott-Heron reminded me that poetry was a living, moving form, aware of its own weakness and aiming for connection. </p>
<p id="rw-p_131470-00002">It is one thing to write poems; it is another to stand in the face of a crowd and sing those poems into space. In a letter to his editor Jamie Byng in 2001, Gil wrote: ‘I feel as much like a comedian when I’m singing at times as I do when I come out at the beginning and just stand there reaching for the audience, trying to feel what kind of spirits are there and where they are and where I need to start to take over the house . . . it is more or less what I have learned that I have to do, come out and feel the house, it is <i>standing up</i>, it is coming out to stand in the face of evil spirits; to call them and raise the stakes. To say that I believe in mine enough to stand in the light. And to show them that I am not alone.’ 
         </p>
<p id="rw-p_131470-00003">	I don’t see it as such a grand title any more. I see it as a social role. For me, ‘poet’ describes a way of being in the world, a way of being with the sorrow and the joy, in communication with your truer selves, and seeking a connection with the truer selves of others. For me a poet is a person who says, ‘I believe in mine enough to stand in the light. And to show them that I am not alone.’ </p>
<p id="rw-p_131470-00004">I first discovered Gil on my own terms at fourteen. It was <i>Pieces of a Man</i> and his storytelling moved me. I came back to him at nineteen, and by then it was his politics. I read The Vulture in my twenties and sensed a writer desperate to master their surroundings, to put their stamp on all existence. Each time I’ve come back to him I have reconnected with the necessity of his truth-telling. </p>
<p id="rw-p_131470-00005">	I write this at the beginning of 2019; the world looms strangely up around us and poets speak from all corners of the globe. You hear them on YouTube or SoundCloud, or on street corners or in theatres or in a bar at night. They make their presence felt alone, or over beats and instrumentals, over rimshots, muted brass or looped piano sequences; the texture of our culture is thick with the words of young poets and old, trying to find meaning, trying to save moments, trying to get hold of their edges and pull themselves through, pull their whole tribe through. We can sense Gil’s outline here, stalking the boundaries, raising the spirits at the beginning of a show. </p>
<p id="rw-p_131470-00006">He did it then, so we can do it now. 
         </p>
<p id="rw-p_131470-00007">Here’s to him. </p>
<p id="rw-p_131470-00008" style="text-align: right;">Kate Tempest</p>
<p id="rw-p_131470-00009" style="text-align: right;">London, 2019
         </p>
<p id="rw-p_131470-00010"><a id="pb-rw_xviii">
</a></p><a id="pb-rw_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847677440_intro.vue?d738c606